import React from 'react';
import { Input, DatePicker, InputNumber, Select, Radio  } from 'antd';
import SearchRetrieve from '../../common/SearchRetrieve.new.js';
import { lowerToUpper } from '../../shared/formatElem';
import { getMatchOption } from '../../shared/selectFn';
import UploadFile from '../../common/UploadFile';
import format from '../../shared/format';
import API_URL from '../../../common/url';
import moment from 'moment';

const Option = Select.Option;
const RadioGroup = Radio.Group;
const TextArea = Input.TextArea;
const dateFormat = "YYYY-MM-DD";

function UpdateUI(props) {
    const {
        saveParams,
        baList,
        fileList,
        currencyList,
        signingUnitList,
        belongingToUnitList,
        relationContractList,
        sponsorWritable,
        proCodeWritable,
        customerWritable,
        handleChange,
        handleUploadChange,
        handleChangeRateCanEdit,
        rateCanEdit,
    } = props;
    saveParams.isRealitySettle=saveParams.contractOrLetterIsSign == 1? saveParams.isRealitySettle?saveParams.isRealitySettle:0:null;
    saveParams.isMsaSpecialContractReduce=saveParams.isRealitySettle == 0?saveParams.isDiscountTermValidity ==1?saveParams.isMsaSpecialContractReduce?saveParams.isMsaSpecialContractReduce:0:null:null;
    const {
        isClinicalProject,
        jdeApplyIsInvestigationExists,
        contractOrLetterIsSign,
        natureOfContract,
        customerProjectCode,
        customerJdeCode,
        contractRelationSite,
        contractIsSpecifiesAmount,
        contractAmount,
        taxationFee,
        rate,
        contractStartDate,
        contractEndDate,
        contractRelationSiteComment,
        investigationName,
        relationJdeId,
        sponsorName,
        customerCompanyName,
        lineOfBusinessString,
        secondLineNames,
        belongingToUnit,
        currencyExchangeRateId,               // 币种编码
        exchangeRate,                         //汇率
        currencyName,                         // 币种名字
        signingUnit,
        investigationPauseReason,
        isRealitySettle=0,//是否据实计算
        isMsaSpecialContractReduce=0,//是否从合同中扣减
        isMsaSpecialDiscountCustom, //是否优惠客户
        isDiscountTermValidity, //是否有效期内
        discountContractAmount,
    } = saveParams;
    const currencyCode = getMatchOption(currencyList, 'currencyExchangeRateId', currencyExchangeRateId).currencyCode;

    const relationContractOptions = relationContractList.map(i => <Option key={String(i.investigationJdeContractId)}>{i.investigationJdeContractCode}</Option>);
    const baOptions = baList.map(d => <Option key={String(d.customerCompanyBaId)}>{format('joint', d.userCompellation, d.employeeCode)}</Option>);
    const currencyOption = currencyList.map(i => <Option key={String(i.currencyExchangeRateId)}>{`${i.currencyName}(${i.currencyCode})`}</Option>);
    const signingUnitOptions = signingUnitList.map(i => <Option key={String(i.unitOfSigningId)}>{i.unitOfSigningName}</Option>);
    const belongingToUnitOptions = belongingToUnitList.map(i => <Option key={String(i.unitOfBelongingId)}>{i.unitOfBelongingName}</Option>);
    
    const newContractStartDate = contractStartDate ? moment(contractStartDate) : null;
    const newContractEndDate = contractEndDate ? moment(contractEndDate) : null;
    const asterisk = <span style={{color: 'red'}}>*</span>;

    const isRealitySettleed = isRealitySettle === 0;// 据实结算 否
    const isMsaSpecialContractReduceed = isMsaSpecialContractReduce == '1';// MSA特殊优惠从合同额中扣减
    const isMsaSpecialDiscountCustomed = isMsaSpecialDiscountCustom == 1 ;
    const isDiscountTermValidityed = isDiscountTermValidity == 1 ;

    const contractHasSelected = contractOrLetterIsSign != undefined;                     // 合同是否签署已选
    const contractHasSigned = contractOrLetterIsSign == '1';                             // 合同已签署
    const CNY = currencyCode === 'CNY';

    // 合同税率rate
    let showRateMes = rate ? rate < 6 || rate > 8 : false;
    if( (!rate || rate == '') && (!taxationFee || taxationFee == '') && rateCanEdit) handleChangeRateCanEdit (false);
    if(rateCanEdit == 'rmb') {
        let rateValue = '';
        if ((taxationFee || taxationFee === 0) && (contractAmount || contractAmount === 0)) {
            if (contractAmount - taxationFee == 0) {
                if (contractAmount === 0) {
                    rateValue = 0;
                } else {
                    rateValue = 100;
                }
            } else {
                rateValue = taxationFee / (contractAmount - taxationFee) * 100;
                rateValue = Number.isNaN(rateValue) ? '' : myFixed(rateValue,2);
            }
            if( rateValue != rate && rateValue != '') {
                handleChangeRateCanEdit ('rmb');
                handleChange(rateValue, 'rate', false);
            }
        }
        if(rateValue == '' && rate != null){
            handleChangeRateCanEdit (false);
            handleChange(null, 'rate', false);
        }
    }
    if(rateCanEdit == 'rate') {
        let taxationFeeValue = '';
        if ((rate || rate === 0) && (contractAmount || contractAmount === 0)) {
            taxationFeeValue = contractAmount - contractAmount / ( 1 + rate / 100 );
            taxationFeeValue = Number.isNaN(taxationFeeValue) ? '' : myFixed(taxationFeeValue,2);
            if( taxationFeeValue != taxationFee && taxationFeeValue != '') {
                handleChangeRateCanEdit ('rate');
                handleChange(taxationFeeValue, 'taxationFee', false);
            }
        }
        if(taxationFeeValue == '' && taxationFee != null){
            handleChangeRateCanEdit (false);
            handleChange(null, 'taxationFee', false);
        }
    }

    //优惠金额（不含税）
    let discountContractAmountNoTaxValue ='';
    if((discountContractAmount || discountContractAmount == 0)&& (rate || rate == 0)){
        discountContractAmountNoTaxValue = discountContractAmount*(1-rate/100);
        discountContractAmountNoTaxValue = Number.isNaN(discountContractAmountNoTaxValue) ? '' : myFixed(discountContractAmountNoTaxValue,2)
        // handleChange(discountContractAmountNoTaxValue, 'discountContractAmountNoTax')
    }
    function myFixed(num, digit) {
            if(Object.is(parseFloat(num), NaN)) {
            return console.log(`传入的值：${num}不是一个数字`);
            }
            num = parseFloat(num);
            return (Math.round((num + Number.EPSILON) * Math.pow(10, digit)) / Math.pow(10, digit)).toFixed(digit);
        }

    //判断用户是否是特殊优惠客户和是否在优惠有效期内
    function customerCompanyChange(value){
        const MsaSpecialDiscountCustom=value.isMsaSpecialDiscountCustom;
        const DiscountTermValidity=value.isDiscountTermValidity;
        handleChange(MsaSpecialDiscountCustom, 'isMsaSpecialDiscountCustom')
        handleChange(DiscountTermValidity, 'isDiscountTermValidity')
    }

    function getContractDom(key, width, disabled = true) {
        return (
            <InputNumber
                maxLength="17"
                precision={2}
                disabled={!disabled}
                max={99999999999}
                style={{ width }}
                value={saveParams[key]}
                formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                parser={value => value.replace(/\￥\s?|(,*)/g, '')}
                onChange={value => handleChange(value, key)}
                />
        );
    }

    return (
        <div>
            <li className="preview-item">
                <div className="item">
                    <label className="ui-label">系统中是否有此项目</label>
                    <span className="ui-text">
                        {jdeApplyIsInvestigationExists == '1' ? '是' : '否'}
                    </span>
                </div>
            </li>
            <li className="preview-item">
                <div className="item">
                    <label className="ui-label">项目简称</label>
                    <span className="ui-text">
                        {investigationName}
                    </span>
                </div>
            </li>
            <li className="preview-item">
                <div className="item">
                    <label className="ui-label">此项目是否为临床项目</label>
                    <span className="ui-text">
                        {isClinicalProject ? '是' : isClinicalProject == 0 ? '否' : ''}
                    </span>
                </div>
            </li>
            <li className="preview-item">
                <div className="item">
                    <label className="ui-label">合同或函证是否签署</label>
                    <span className="ui-text">
                        { contractOrLetterIsSign ? '是' : '否' }
                    </span>
                </div>
            </li>
            <li className="preview-item">
                <div className="item">
                    <label className="ui-label">{asterisk}合同性质</label>
                    <span className="ui-text">
                        <Select
                            placeholder="请选择"
                            style={{width: 182}}
                            value={natureOfContract}
                            onChange={value => handleChange(value, 'natureOfContract')}
                        >
                            <Option value='TERMINATION_CONTRACT'>终止合同</Option>
                            <Option value='TERMINATION_LETTER'>终止函</Option>
                        </Select>
                    </span>
                </div>
            </li>
            {
                contractHasSelected &&
                <div>
                    <li className="preview-item">
                        <div className="item">
                            <label className="ui-label">{asterisk}关联JDE</label>
                            <span className="ui-text">
                                <Select
                                    placeholder="请选择"
                                    style={{width: 182}}
                                    onChange={value => handleChange(value, 'relationJdeId')}
                                    value={relationJdeId ? String(relationJdeId) : undefined}
                                    allowClear={true}
                                >
                                    {relationContractOptions}
                                </Select>
                            </span>
                        </div>
                    </li>
                    <li className="preview-item">
                        <div className="item">
                            <label className="ui-label">{sponsorWritable && asterisk}申办方</label>
                            <span className="ui-text">
                                {
                                    sponsorWritable ?
                                        <SearchRetrieve
                                            keyword='customerCompanyName'
                                            style={{ width: 182 }}
                                            value={sponsorName}
                                            params={{ limit: 20, natureName: '申办方' }}
                                            placeholder="输入名称检索"
                                            url={API_URL.investigation.queryCustomerCompanyByName}
                                            config={{ id: 'customerCompanyId', name: 'customerCompanyName' }}
                                            onChange={option => handleChange(option, 'sponsor')}
                                        />
                                    :
                                        sponsorName
                                }
                            </span>
                        </div>
                    </li>
                    <li className="preview-item">
                        <div className="item">
                            <label className="ui-label">{proCodeWritable && asterisk}项目编号</label>
                            <span className="ui-text">
                                {
                                    proCodeWritable ?
                                        <Input
                                            placeholder="请输入"
                                            style={{width: 182}}
                                            value={customerProjectCode}
                                            onChange={e => handleChange(e.target.value, 'customerProjectCode')}
                                        />
                                    :
                                        customerProjectCode
                                }
                            </span>
                        </div>
                    </li>
                    <li className="preview-item">
                        <div className="item">
                            <label className="ui-label">{customerWritable && asterisk}客户全名</label>
                            <span className="ui-text">
                                {
                                    customerWritable ?
                                        <SearchRetrieve
                                            keyword='customerCompanyName'
                                            style={{ width: 182 }}
                                            value={customerCompanyName}
                                            params={{ limit: 20 }}
                                            placeholder="输入名称检索"
                                            url={API_URL.investigation.queryCustomerCompanyByName}
                                            config={{ id: 'customerCompanyId', name: 'customerCompanyName' }}
                                            onChange={option => {
                                                handleChange(option, 'customerCompany')
                                                customerCompanyChange(option)
                                            }}
                                        />
                                    :
                                        customerCompanyName
                                }
                            </span>
                        </div>
                    </li>
                    <li className="preview-item">
                        <div className="item">
                            <label className="ui-label">客户JDE号</label>
                            <span className="ui-text">{customerJdeCode}</span>
                        </div>
                    </li>
                    <li className="preview-item">
                        <div className="item">
                            <label className="ui-label">{customerWritable && asterisk}BA</label>
                            <span className="ui-text">
                                {
                                    customerWritable ?
                                    <SearchRetrieve
                                        keyword='keyWord'
                                        style={{ width: 182 }}
                                        placeholder="输入姓名/工号检索"
                                        value={saveParams.baUserName}
                                        params={{ limit: 20, roleCodes: 'BA,BAL' }}
                                        url={API_URL.teaching.queryEmpListByRoleCode}
                                        config={{ id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user' }}
                                        onChange={(option) => handleChange(option, 'baUser')}
                                    />
                                    :
                                    saveParams.baUserName
                                }
                            </span>
                        </div>
                    </li>
                    <li className="preview-item">
                        <div className="item">
                            <label className="ui-label">业务线</label>
                            <span className="ui-text">{lineOfBusinessString}</span>
                        </div>
                    </li>
                    {
                        secondLineNames &&
                        <li className="preview-item">
                            <div className="item">
                                <label className="ui-label">执行业务线二级分类</label>
                                <span className="ui-text">{secondLineNames}</span>
                            </div>
                        </li>
                    }
                    <li className="preview-item">
                        <div className="item">
                            <label className="ui-label">{asterisk}合同关联中心</label>
                            <span className="ui-text">
                                <RadioGroup onChange={e => handleChange(e.target.value, 'contractRelationSite')} value={contractRelationSite}>
                                    <Radio value='SINGLE'>单中心</Radio>
                                    <Radio value='MULTICENTER'>多中心</Radio>
                                </RadioGroup>
                            </span>
                        </div>
                    </li>
                    <li className="preview-item">
                        <div className="item">
                            <label className="ui-label">{asterisk}合同签署单位</label>
                            <span className="ui-text">
                                <Select
                                    allowClear={true}
                                    placeholder="请选择"
                                    style={{width: 182}}
                                    value={signingUnit ? String(signingUnit) : undefined}
                                    onChange={value => handleChange(value, 'signingUnit')}
                                >
                                    {signingUnitOptions}
                                </Select>
                            </span>
                        </div>
                    </li>
                    <li className="preview-item">
                        <div className="item">
                            <label className="ui-label">{asterisk}收入归属单位</label>
                            <span className="ui-text">
                                <Select
                                    allowClear={true}
                                    placeholder="请选择"
                                    style={{width: 182}}
                                    disabled={!saveParams.signingUnit}
                                    value={belongingToUnit ? String(belongingToUnit) : undefined}
                                    onChange={value => handleChange(value, 'belongingToUnit')}
                                >
                                    {belongingToUnitOptions}
                                </Select>
                            </span>
                        </div>
                    </li>
                    <li className="preview-item">
                        <div className="item">
                            <label className="ui-label">{asterisk}合同中是否明标合同金额</label>
                            <span className="ui-text">
                                <RadioGroup onChange={e => handleChange(e.target.value, 'contractIsSpecifiesAmount')} value={contractIsSpecifiesAmount}>
                                    <Radio value='1'>是</Radio>
                                    <Radio value='0'>否</Radio>
                                </RadioGroup>
                            </span>
                        </div>
                    </li>
                    <li className="preview-item">
                        <div className="item">
                            <label className="ui-label">{asterisk}币种</label>
                            <span className="ui-text">
                                <Select
                                    placeholder="请选择"
                                    style={{width: 182}}
                                    value={currencyExchangeRateId ? String(currencyExchangeRateId) : undefined}
                                    onChange={value => handleChange(value, 'currencyExchangeRateId')}
                                >
                                    {currencyOption}
                                </Select>
                            </span>
                        </div>
                    </li>
                    <li className="preview-item">
                        <div className="item">
                            <label className="ui-label">{!CNY && asterisk}汇率</label>
                            <span className="ui-text">
                                {
                                    !CNY ?
                                        <InputNumber
                                            placeholder="请输入"
                                            style={{width: 182}}
                                            value={exchangeRate}
                                            onChange={value => handleChange(value, 'exchangeRate')}
                                        />
                                    :
                                        exchangeRate
                                }
                            </span>
                        </div>
                    </li>
                </div>
            }
            {
                !contractHasSigned ?
                    CNY ?
                        <li className="preview-item">
                            <div className="item">
                                <label className="ui-label">{asterisk}预计合同金额/人民币</label>
                                <span className="ui-text">
                                    {getContractDom('expectContractAmount', 182)}&nbsp;元
                                </span>
                            </div>
                            {lowerToUpper(saveParams.expectContractAmount, 230)}
                        </li>
                    :
                        <div className="jde-rate">
                            <div className="left" style={{ width: '50%' }}>
                                <div className="left lable" style={{ width: '50%' }}>{asterisk}预计合同金额/原币</div>
                                <div className="right text-com" style={{ width: '50%' }}>
                                    {getContractDom('expectContractAmount', 100)}&nbsp;{currencyName}
                                </div>
                            </div>
                            <div className="right" style={{ width: '50%' }}>
                                <div className="left lable" style={{ width: '50%' }}>预计合同金额/人民币</div>
                                <div className="right text-com" style={{ width: '50%' }}>
                                    {format('money', saveParams.expectContractAmount, exchangeRate)}&nbsp;元
                                </div>
                            </div>
                        </div>
                :
                    CNY ?
                        <div>
                            <li className="preview-item">
                                <div className="item">
                                    <label className="ui-label">{asterisk}合同额含税/人民币</label>
                                    <span className="ui-text">
                                        {getContractDom('contractAmount', 182)}&nbsp;元
                                    </span>
                                </div>
                            </li>
                            {lowerToUpper(saveParams.contractAmount, 245)}
                            <li className="preview-item">
                                <div className="item">
                                    <label className="ui-label">{asterisk}合同税率</label>
                                    <span className="ui-text" >
                                        {getContractDom('rate', 182, !rateCanEdit || rateCanEdit == 'rate')} &nbsp;%
                                        {
                                            showRateMes && <span style={{ color: 'red', padding: '0 10px' }}>税率范围：6%~8%</span>
                                        }
                                    </span>
                                </div>
                            </li>
                            <div className="FeeBackground" style={{ width: '80%' }}>
                                <div style={{ position: 'absolute', top: 0, left: 0, right: '88%', bottom: 0, background: '#f9f9f9', borderRight: "1px solid #ccc" }}>
                                    <span style={{ position: "absolute", left: "10px", top: "50%", transform: 'translateY(-50%)' }}>&nbsp;其中<br />需扣除</span>
                                </div>
                                <div style={{ height: "100%", marginLeft: '12%' }}>
                                    <li className="preview-item">
                                        <div className="item">
                                            <label className="ui-label">实报实销(不含税)/人民币</label>
                                            <span className="ui-text">
                                                {getContractDom('actualExpenseFee', 182)}&nbsp;元
                                            </span>
                                        </div>
                                    </li>
                                    {lowerToUpper(saveParams.actualExpenseFee)}
                                    <li className="preview-item">
                                        <div className="item">
                                            <label className="ui-label">实报实销税费/人民币</label>
                                            <span className="ui-text">
                                                {getContractDom('actualFee', 182)}&nbsp;元
                                            </span>
                                        </div>
                                    </li>
                                    {lowerToUpper(saveParams.actualFee)}
                                    <li className="preview-item">
                                        <div className="item">
                                            <label className="ui-label">{asterisk}合同额税费/人民币</label>
                                            <span className="ui-text">
                                                {getContractDom('taxationFee', 182, !rateCanEdit || rateCanEdit == 'rmb')}&nbsp;元
                                            </span>
                                        </div>
                                    </li>
                                    {lowerToUpper(saveParams.taxationFee)}
                                </div>
                            </div>
                        </div>
                    :
                        <div className="jde-rate">
                            <div>
                                <div className="left" style={{ width: '55%' }}>
                                    <div className="left lable" style={{ width: '59.4%' }}>{asterisk}合同额含税/原币</div>
                                    <div className="right text-com" style={{ width: '40.6%' }}>
                                        {getContractDom('contractAmount', 100)}&nbsp;{currencyName}
                                    </div>
                                </div>
                                <div className="right" style={{ width: '45%' }}>
                                    <div className="left lable" style={{ width: '50%' }}>合同额含税/人民币</div>
                                    <div className="right text-com" style={{ width: '50%' }}>
                                        {format('money', saveParams.contractAmount, exchangeRate)}&nbsp;元
                                        </div>
                                </div>
                            </div>
                            <div className="jde-top">
                                <div className="left lable" style={{ width: '10%', textAlign: 'center', borderRight: 0 }}>其中<br />需扣除</div>
                                <div className="right jde-left" style={{ width: '90%' }}>
                                    <div>
                                        <div className="left" style={{ width: '50%' }}>
                                            <div className="left lable" style={{ width: '50%' }}>实报实销(不含税)/原币</div>
                                            <div className="right text-com" style={{ width: '50%' }}>
                                                {getContractDom('actualExpenseFee', 100)}&nbsp;{currencyName}
                                            </div>
                                        </div>
                                        <div className="right" style={{ width: '50%' }}>
                                            <div className="left lable" style={{ width: '50%' }}>实报实销(不含税)/人民币</div>
                                            <div className="right text-com" style={{ width: '50%' }}>
                                                {format('money', saveParams.actualExpenseFee, exchangeRate)}&nbsp;元
                                            </div>
                                        </div>
                                    </div>
                                    <div className="jde-bottom">
                                        <div className="left" style={{ width: '50%' }}>
                                            <div className="left lable" style={{ width: '50%' }}>实报实销税费/原币</div>
                                            <div className="right text-com" style={{ width: '50%' }}>
                                                {getContractDom('actualFee', 100)}&nbsp;{currencyName}
                                            </div>
                                        </div>
                                        <div className="right" style={{ width: '50%' }}>
                                            <div className="left lable" style={{ width: '50%' }}>实报实销税费/人民币</div>
                                            <div className="right text-com" style={{ width: '50%' }}>
                                                {format('money', saveParams.actualFee, exchangeRate)}&nbsp;元
                                            </div>
                                        </div>
                                    </div>
                                    <div className="jde-bottom">
                                        <div className="left" style={{ width: '50%' }}>
                                            <div className="left lable" style={{ width: '50%' }}>{asterisk}合同额税费/原币</div>
                                            <div className="right text-com" style={{ width: '50%' }}>
                                                {getContractDom('taxationFee', 100, !rateCanEdit || rateCanEdit == 'rmb')}&nbsp;元
                                            </div>
                                        </div>
                                        <div className="right" style={{ width: '50%' }}>
                                            <div className="left lable" style={{ width: '50%' }}>合同额税费/人民币</div>
                                            <div className="right text-com" style={{ width: '50%' }}>
                                                {format('money', saveParams.taxationFee, exchangeRate)}&nbsp;元
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="jde-top">
                                <div className="left lable" style={{ width: '32.6%' }}>{asterisk}合同税率</div>
                                <div className="right text-com" style={{ width: '67.4%' }}>
                                    {getContractDom('rate', 100, !rateCanEdit || rateCanEdit == 'rate')} &nbsp;%
                                            {
                                                showRateMes && <span style={{ color: 'red', padding: '0 10px' }}>税率范围：6%~8%</span>
                                            }
                                </div>
                            </div>
                        </div>
            }
            {
                contractHasSigned &&
                <div>
                    <li className="preview-item">
                        <div className="item">
                            <label className="ui-label">{asterisk}是否据实结算</label>
                            <span className="ui-text">
                                <RadioGroup onChange={e => handleChange(e.target.value, 'isRealitySettle')} value={isRealitySettle}>
                                    <Radio key={1} value={1}>是</Radio>
                                    <Radio key={0} value={0}>否</Radio>
                                </RadioGroup>
                            </span>
                        </div>
                    </li>
                    {
                        (isRealitySettleed && isDiscountTermValidityed) &&
                        <div>
                            <li className="preview-item">
                                <div className="item">
                                    <label className="ui-label" style={{padding:'0'}}>{asterisk}MSA特殊优惠是否从合同额中扣减</label>
                                    <span className="ui-text">
                                        <RadioGroup onChange={e => handleChange(e.target.value, 'isMsaSpecialContractReduce')} value={isMsaSpecialContractReduce}>
                                            <Radio key={1} value={1}>是</Radio>
                                            <Radio key={0} value={0}>否</Radio>
                                        </RadioGroup>
                                    </span>
                                </div>
                            </li>
                            {
                                isMsaSpecialContractReduceed && 
                                    <div>
                                        <li className="preview-item">
                                            <div className="item">
                                                <label className="ui-label">{asterisk}优惠金额（含税）/人民币</label>
                                                <span className="ui-text">
                                                    {getContractDom('discountContractAmount', 182)}&nbsp;元
                                                </span>
                                            </div>
                                        </li>
                                        <li className="preview-item">
                                            <div className="item">
                                                <label className="ui-label">优惠金额（不含税）/人民币</label>
                                                <span className="ui-text" style={{ width: 186 }}>
                                                    {discountContractAmountNoTaxValue}&nbsp;元
                                                </span>
                                            </div>
                                        </li>
                                    </div>
                            }
                        </div>
                    }
                </div>
            }
            <li className="preview-item">
                <div className="item">
                    <label className="ui-label">{asterisk}合同开始时间</label>
                    <span className="ui-text">
                        <DatePicker
                            placeholder="请选择"
                            style={{width: 182}}
                            format={dateFormat}
                            value={newContractStartDate}
                            onChange={(date, dateString) => handleChange(dateString, "contractStartDate")}
                        />
                    </span>
                </div>
            </li>
            <li className="preview-item">
                <div className="item">
                    <label className="ui-label">{asterisk}合同结束时间</label>
                    <span className="ui-text">
                        <DatePicker
                            placeholder="请选择"
                            style={{width: 182}}
                            format={dateFormat}
                            value={newContractEndDate}
                            onChange={(date, dateString) => handleChange(dateString, "contractEndDate")}
                        />
                    </span>
                </div>
            </li>
            <li className="preview-item">
                <div className="item">
                    <label className="ui-label">项目终止原因</label>
                    <span className="ui-text">{investigationPauseReason}</span>
                </div>
            </li>
            <li className="preview-item">
                <div className="item">
                    <label className="ui-label">备注</label>
                    <span className="ui-text">
                        <TextArea
                            value={contractRelationSiteComment}
                            placeholder="请输入"
                            style={{width: 300, height: 80}}
                            onChange={e => handleChange(e.target.value, 'contractRelationSiteComment')}
                        />
                    </span>
                </div>
            </li>
            <li className="preview-item">
                <div className="item">
                    <label className="ui-label">{asterisk}上传附件</label>
                    <span className="ui-text">
                        <UploadFile
                            data={{
                                jdeApplyId: '',
                                path: Date.now(),
                                uploadType: 'CONTRACT',
                            }}
                            fileList={fileList}
                            uploadUrl={API_URL.contract.uploadJdeCodeEnclosure}
                            removeUrl={API_URL.contract.deleteJdeCodeEnclosure}
                            onChange={handleUploadChange}
                        />
                    </span>
                </div>
            </li>
        </div>
    );
}

export default UpdateUI;


// WEBPACK FOOTER //
// ./src/components/contractManagement/terminationApply/UpdateUI.js